export const updateTopCoverAnisotropy = (obj) => {
    const topCoverMesh = obj.children.find((child) =>
        ["fanera", "rezina"].some((keyword) => child.material.name.includes(keyword)),
    );
    if (!topCoverMesh) return;

    const map = topCoverMesh.material.map;
    const normalMap = topCoverMesh.material.normalMap;

    if (map) map.anisotropy = 16;
    if (normalMap) normalMap.anisotropy = 16;
};
